module.exports = __webpack_public_path__ + "static/media/blog-card-img.bc756415.jpg";